import React from "react";
import { useAuth } from "../../Hooks/useFirebase";
import styles from "./header.module.css";

const UserShow = () => {
  const { user, signout } = useAuth();
  const displayName = user?.displayName;
  if (displayName) {
    return (
      <div className={styles["user-show"]}>
        <h3>Welcome, {displayName}</h3>
        <button className="outline border" onClick={signout}>
          logout
        </button>
      </div>
    );
  } else {
    return null;
  }
};

export default UserShow;
